import React from "react";
import TransportationProviderTable from "src/pages/setting/transportation-provider";

export default function TransportationProviderPage() {
  return <TransportationProviderTable />;
}
